export function getInitials(user: { display_name?: string | null }) {
  if (!user.display_name) {
    return ''
  }
  const parts = user.display_name
    .split(/\s+/g)
    .filter(Boolean)
    .map((s) => s[0])
  if (parts) {
    return parts.join('').substring(0, 2)
  }
  return ''
}

function letterToNumber(val: string) {
  if (!val) {
    return 0
  }

  const base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let result = 0
  for (let i = 0, j = val.length - 1; i < val.length; i += 1, j -= 1) {
    result += Math.pow(base.length, j) * (base.indexOf(val[i]) + 1)
  }

  return result
}

export function getUserBackgroundColor(user: {
  display_name?: string | null | undefined
  displayName?: string | null | undefined
  name?: string
}) {
  const colors = [
    { hex: '#ff8f72', name: 'Rocket' },
    { hex: '#ffbead', name: 'Dusk' },
    { hex: '#ffc402', name: 'Sunshine' },
    { hex: '#ffe380', name: 'Lime' },
    { hex: '#56daa3', name: 'Everglade' },
    { hex: '#79f3c0', name: 'Aqua' },
    { hex: '#00c8e6', name: 'Atmos' },
    { hex: '#b3d5ff', name: 'Ocean' },
    { hex: '#998dd9', name: 'Empire' },
    { hex: '#c1b6f3', name: 'Magenta' },
    { hex: '#5592e2', name: 'Blue' },
    { hex: '#5a6b88', name: 'Slate' },
    { hex: '#d3f177', name: 'Grass' }
  ]

  const displayName = user.display_name || user.displayName || user.name

  if (!displayName) {
    return '#ffffff'
  }
  const matches = displayName.match(/\b(\w)/g)
  if (matches) {
    let val = letterToNumber(matches[0]) + letterToNumber(matches[1]) // convert to a number (0-25)
    val = Math.floor(val / 4)
    return colors[Math.min(val, colors.length - 1)].hex
  }

  return '#fff'
}
